import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=5e73b307&"
import script from "./image-viewer.vue?vue&type=script&lang=js&"
export * from "./image-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e73b307')) {
      api.createRecord('5e73b307', component.options)
    } else {
      api.reload('5e73b307', component.options)
    }
    module.hot.accept("./image-viewer.vue?vue&type=template&id=5e73b307&", function () {
      api.rerender('5e73b307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/image/src/image-viewer.vue"
export default component.exports